export const tr = {
    LEFT: 'Sol: önceki gün gider. Ertesi gün Taşımak',
    RIGHT: 'sağ. | Bir sonraki satıra Taşıyın.',
    DOWN: 'Bir önceki satıra gitme.',
    UP: 'PgUp: bir önceki aya gider.',
    PGUP: 'PgDown: bir sonraki aya gitme.',
    PGDOWN: 'Home: önceki yıl gider.',
    HOME: 'Bitiş: gelecek yıl Taşımak.',
    END: 'Esc/Bugün/Kapat: takvim kapatın.',
    ESC: 'Klavye Talimatları'
};
